<template>
  <a v-if="csvURI" :download="downloadName" :href="csvURI">Export to CSV</a>
</template>

<script>
import ObjectsToCsv from "objects-to-csv";
import moment from "moment";
export default {
  props: ["data", "type"],
  data() {
    return {
      csvURI: null,
      services: null
    };
  },
  watch: {
    data: function() {
      this.csvURI = null;
      this.createCSVContent();
    }
  },
  computed: {
    downloadName() {
      const date = moment().format("MM-DD-YYYY");
      return `${this.type}--${date}.csv`;
    }
  },
  methods: {
    async createCSVContent() {
      const copyData = JSON.parse(JSON.stringify(this.data));
      const requests = copyData.map(request => {
        const cleanRequest = {
          submitted: moment(request.createdAt).format("MM-DD-YYYY h:mm a"),
          link: `https://compliance.fbhl.com/${this.type}/${request._id}`,
          name: request.name,
          email: request.email,
          phone: request.phone,
          address: request.mailAddress,
          city: request.city,
          state: request.state,
          zip: request.zipCode,
          services: request.services,
          last_updated: moment(request.updatedAt).format("MM-DD-YYYY h:mm a")
        };
        cleanRequest.services.forEach(service => {
          cleanRequest[service.name] = service.is_complete
            ? "complete"
            : "incomplete";
        });
        delete cleanRequest.services;
        return cleanRequest;
      });
      const csvContent = await new ObjectsToCsv(requests).toString(true, true);
      this.csvURI = `data:text/csv;charset=utf-8,${encodeURI(csvContent)}`;
    }
  },
  mounted() {
    this.createCSVContent();
  }
};
</script>

<style scoped lang="scss">
</style>